(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-material-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pb-material-guide-controller')) {
    customElements.define('pb-material-guide-controller', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.productInfo = this.closest('.product-info');
        this.modal = document.getElementById(this.getAttribute('dialog-id'));
        this.applyPlaceholder = () => {
          this.productInfo?.querySelectorAll('.ap-options__modal').forEach(trigger => {
            const title = trigger.querySelector('.apo-modal__title');
            if (title?.textContent.toLowerCase().includes('material')) trigger.classList.add('pb-replaced-material-guide');
          });
          const inputs = this.productInfo?.querySelectorAll('input[field-name="BACK" i], textarea[field-name="BACK" i], input[field-name="INSIDE" i], textarea[field-name="INSIDE" i]');
          inputs?.forEach(input => { input.placeholder = this.getAttribute('back-placeholder'); });
          if (this.hasAttribute('data-pb-engraving-example')) this.decorateEngraving();
        };
        this.applyPlaceholder();
        if (this.productInfo) {
          this.observer = new MutationObserver(() => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => { this.frame = null; this.applyPlaceholder(); });
          });
          this.observer.observe(this.productInfo, {childList: true, subtree: true});
        }
        this.modal?.addEventListener('click', async event => {
          const choice = event.target.closest('[data-pb-material-choice]');
          const close = event.target.closest('[data-pb-material-close]');
          if (!choice && !close) return;
          event.preventDefault();
          const formId = this.modal.dataset.pbForm;
          const position = this.modal.dataset.pbPosition;
          const selector = choice && 'input[form="' + CSS.escape(formId) + '"][data-option-position="' + CSS.escape(position) + '"][value="' + CSS.escape(choice.dataset.pbMaterialChoice) + '"]';
          const input = selector && this.productInfo?.querySelector(selector);
          await this.modal.hide();
          if (input && !input.checked) {
            const label = this.productInfo.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (label) label.click();
          }
        }, {signal: this.abortController.signal});
      }
      decorateEngraving() {
        if (!this.productInfo) return;
        this.productInfo.querySelectorAll('h3, h4, h5, h6').forEach(heading => {
          if (heading.textContent.trim() === "YOUR CHILD'S BIRTH STORY, ENGRAVED FOREVER:") {
            heading.textContent = this.dataset.pbHeading;
            heading.classList.add('pb-engraving-example-heading');
          }
        });
        ['FRONT', 'BACK'].forEach(side => {
          const input = this.productInfo.querySelector('input[field-name="' + side + '"]');
          const field = input?.closest('.ap-options__text-container');
          const title = field?.querySelector('.apo-title');
          const row = field?.querySelector('.ap-label-tooltip');
          if (!field || !title || !row) return;
          const prefix = side === 'FRONT' ? 'pbFront' : 'pbBack';
          const label = this.dataset[prefix + 'Label'];
          if (title.textContent !== label) title.textContent = label;
          field.classList.add('pb-engraving-example-field');
          if (!row.querySelector('.pb-engraving-placement')) {
            const placement = document.createElement('span');
            placement.className = 'pb-engraving-placement';
            placement.textContent = this.dataset[prefix + 'Placement'];
            row.append(placement);
          }
          if (!field.querySelector('.pb-engraving-help')) {
            const help = document.createElement('p');
            help.className = 'pb-engraving-help';
            help.id = input.id + '-pb-help';
            help.textContent = this.dataset[prefix + 'Help'];
            row.after(help);
            const describedBy = input.getAttribute('aria-describedby') || '';
            input.setAttribute('aria-describedby', (describedBy + ' ' + help.id).trim());
          }
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class PBFinishRules extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.picker = this.closest('variant-picker');
        this.form = document.getElementById(this.getAttribute('form-id'));
        const options = JSON.parse(this.querySelector('script').textContent);
        this.material = options.find(option => /material/i.test(option.name));
        this.color = options.find(option => /color|finish|finsih/i.test(option.name));
        if (!this.form || !this.picker || !this.material || !this.color) return;
        if (!['white', 'silver'].every(name => this.color.values.some(value => value.name.toLowerCase().trim() === name))) return;
        const changed = this.sync();
        if (changed) this.picker.selectCombination({optionValues: this.selection(), productChange: false});
        document.addEventListener('change', event => {
          if (event.target.form === this.form && event.target.matches('input[data-option-position]')) this.sync();
        }, {capture: true, signal: this.controller.signal});
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
    }
    inputs(option) {
      return [...this.form.elements].filter(input => input.matches('input[data-option-position]') && Number(input.dataset.optionPosition) === option.position);
    }
    selection() {
      return [...this.form.elements].filter(input => input.matches('input[data-option-position]:checked')).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map(input => input.value);
    }
    sync() {
      const materialInput = this.inputs(this.material).find(input => input.checked);
      const material = this.material.values.find(value => value.id === materialInput?.value)?.name || '';
      const solidGold = /14\s*k/i.test(material) && /gold/i.test(material);
      const hiddenName = solidGold ? 'silver' : 'white';
      const replacementName = solidGold ? 'white' : 'silver';
      const colors = this.inputs(this.color);
      let changed = false;
      const selected = colors.find(input => input.checked);
      const selectedName = this.color.values.find(value => value.id === selected?.value)?.name.toLowerCase().trim();
      if (selectedName === hiddenName) {
        const replacementId = this.color.values.find(value => value.name.toLowerCase().trim() === replacementName)?.id;
        const replacement = colors.find(input => input.value === replacementId && !input.disabled);
        if (replacement) { replacement.checked = true; changed = true; }
        else {
          const fallback = colors.find(input => !input.disabled && this.color.values.find(value => value.id === input.value)?.name.toLowerCase().trim() !== hiddenName);
          if (fallback) { fallback.checked = true; changed = true; }
        }
      }
      colors.forEach(input => {
        const name = this.color.values.find(value => value.id === input.value)?.name.toLowerCase().trim();
        const hidden = name === hiddenName;
        input.hidden = hidden;
        input.toggleAttribute('data-pb-finish-hidden', hidden);
        [...input.labels].forEach(label => { label.hidden = hidden; label.toggleAttribute('data-pb-finish-hidden', hidden); label.style.display = hidden ? 'none' : ''; });
      });
      return changed;
    }
  }
  if (!customElements.get('pb-finish-rules')) customElements.define('pb-finish-rules', PBFinishRules);
  } catch(e) { console.error(e); }
})();

})();
